"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSession = getSession;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _uuid = _interopRequireDefault(require("uuid"));

var _constants = require("redux-persist/constants");

var _createReducer2 = _interopRequireDefault(require("../createReducer"));

var sessionActions = _interopRequireWildcard(require("./sessionActions"));

var _constants2 = require("../constants");

var _createReducer;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var storageKey = 'session';
var lastActiveTime = new Date();

function updateLastActiveTime() {
  lastActiveTime = new Date();
}

function getSession(state) {
  var now = new Date();
  var stateLastActiveTime = new Date(state.lastActiveTime || lastActiveTime);
  var hasSessionExpired = !state.id || now - stateLastActiveTime > _constants2.sessionDurationMs;

  if (hasSessionExpired) {
    return {
      id: _uuid.default.v4(),
      startTime: now,
      lastActiveTime: lastActiveTime
    };
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    startTime: new Date(state.startTime),
    lastActiveTime: lastActiveTime
  });
}

var onClickorKeyUp = (0, _throttle2.default)(function (store) {
  updateLastActiveTime();
  store.dispatch(sessionActions.refreshSession());
}, 60000);
var sessionReducer = (0, _createReducer2.default)({}, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _constants.REHYDRATE, function (initialIrrelevantState, action) {
  if (_constants2.isServer) {
    return initialIrrelevantState;
  }

  var storageValue = localStorage.getItem(storageKey);
  var cachedSession = storageValue ? JSON.parse(storageValue) : {};
  var state = getSession(cachedSession); // automatically initialize after REHYDRATE

  action.addSideEffect(function (store) {
    window.addEventListener('click', function () {
      return onClickorKeyUp(store);
    });
    window.addEventListener('keyup', function () {
      return onClickorKeyUp(store);
    });
  });
  return state;
}), (0, _defineProperty2.default)(_createReducer, "REFRESH_SESSION", function REFRESH_SESSION(state, action) {
  if (_constants2.isServer) {
    return state;
  }

  var nextState = getSession(state);
  action.addSideEffect(function (store) {
    // write state to localStorage
    localStorage.setItem(storageKey, JSON.stringify(nextState));
  });
  return nextState;
}), _createReducer), false);
var _default = sessionReducer;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/session/sessionReducer.js
// module id = 4357
// module chunks = 25